import React from "react";
import writeXlsxFile from "write-excel-file/browser";
import IconButton from "@material-ui/core/IconButton";
import DescriptionOutlined from "@material-ui/icons/DescriptionOutlined";
import Tooltip from "@material-ui/core/Tooltip";
import { useTranslation } from "react-i18next";

export function TableExcelExportButton({ rows, filename }) {
    const { t } = useTranslation();

    if (!rows || rows.length === 0) {
        return null;
    }

    function handleClick() {
        writeXlsxFile(rows).toFile(filename);
    }

    return (
        <Tooltip title={t('table-excel-export-button.tooltip')}>
            <IconButton onClick={handleClick}>
                <DescriptionOutlined fontSize="small" />
            </IconButton>
        </Tooltip>
    );
}
